export default __webpack_public_path__ + "static/media/avatar_placeholder.9c61cbb3.svg";